exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auditing-all-btn[data-v-1788b602]{\n  margin-left:20px;\n  margin-top:20px;\n}\n.auditing-table[data-v-1788b602]{\n  margin-top: 40px;\n}\n.auditing-pagination[data-v-1788b602]{\n  margin-top:40px;\n  height: 40px;\n  text-align: center;\n}\n.auditing-dialog-textarea[data-v-1788b602] .el-textarea__inner{\n  position: absolute;\n      top: -65px;\n      left: 77px;\n      width: 70%;\n}\n.commonLanguage[data-v-1788b602]{\n  position: absolute;\n  left: 80%;\n  top: 0;\n}\n", ""]);

// exports
